<template>
    <div class="main">
        <div class="basemsg">
            <h6>
                <img src="../../../assets/img/basemsg.png">
                <span>基础信息</span>
            </h6>
            <div class="flexbox con">
                <!-- <div class="cell">
                    <span>配送模式：</span>
                    <p>{{logbaseMsg.ysType}}</p>
                </div> -->
                <div class="cell">
                    <span>运输方式：</span>
                    <p>{{logbaseMsg.ysType}}</p>
                </div>
                <div class="cell">
                    <span>运单号：</span>
                    <p>{{logbaseMsg.ydh}}</p>
                </div>
                <div class="cell">
                    <span>物流单号：</span>
                    <p>{{logbaseMsg.wldh}}</p>
                </div>
                <div class="cell">
                    <span>车次号：</span>
                    <p>{{logbaseMsg.carNo}}</p>
                    <!-- <router-link to="/">详情</router-link> -->
                    <router-link :to="{name: 'VehicleTrajectory', query: {ordercode: orderCode}}">查看车辆轨迹</router-link>
                </div>
                <div class="cell">
                    <span>客户名称：</span>
                    <p>{{logbaseMsg.cusName}}</p>
                </div>
                   <div class="cell">
                    <span>司机电话：</span>
                    <p>{{logbaseMsg.driverTel}}</p>
                </div>
            </div>
        </div>
        <div class="orderstate">
            <h6>
                <img src="../../../assets/img/orderstate.png">
                <span>订单状态</span>
            </h6>
            <div class="con">
                <div class="flexbox item itemtop itempadding">
                    <div class="cell">
                        <p>下单状态</p>
                        <!-- <div class="ico grayi" v-if="logisticsMsg.xdzt == '未制单'"><img src="../../../assets/img/orderstate/state1.png"></div> -->
                        <div class="ico greeni"><img src="../../../assets/img/orderstate/state1.png"></div>
                        <!-- <span class="grayw">未制单</span>
                        <span>制单中</span> -->
                        <span>{{ logisticsMsg.xdzt }}</span>
                    </div>
                    <div class="cell">
                        <p>订单状态评审</p>
                        <div class="ico grayi" v-if="logisticsMsg.pszt == '未评审'"><img src="../../../assets/img/orderstate/state2.png"></div>
                        <div class="ico greeni" v-else><img src="../../../assets/img/orderstate/state2.png"></div>
                        <!-- <span class="grayw">未评审</span>
                        <span>已评审</span> -->
                        <span>{{ logisticsMsg.pszt }}</span>
                    </div>
                    <div class="cell">
                        <p>生产完成状态</p>
                        <div class="ico grayi" v-if="logisticsMsg.sczt == '未生产'"><img src="../../../assets/img/orderstate/state3.png"></div>
                        <div class="ico greeni" v-else><img src="../../../assets/img/orderstate/state3.png"></div>
                        <!-- <span class="grayw">未生产</span>
                        <span>生产中</span> -->
                        <span>{{ logisticsMsg.sczt }}</span>
                    </div>
                    <div class="cell">
                        <p>安排发货状态</p>
                        <div class="ico grayi" v-if="logisticsMsg.apzt == '未安排'"><img src="../../../assets/img/orderstate/state4.png"></div>
                        <div class="ico greeni" v-else><img src="../../../assets/img/orderstate/state4.png"></div>
                        <!-- <span class="grayw">未安排</span>
                        <span>已安排</span> -->
                        <span>{{ logisticsMsg.apzt }}</span>
                    </div>
                    <div class="cell">
                        <p>运输派车</p>
                        <div class="ico grayi" v-if="logisticsMsg.pczt == '未派车'"><img src="../../../assets/img/orderstate/state5.png"></div>
                        <div class="ico bluei" v-else><img src="../../../assets/img/orderstate/state5.png"></div>
                        <!-- <span class="grayw">未派车</span>
                        <span>已派车</span> -->
                        <span>{{ logisticsMsg.pczt }}</span>
                    </div>
                    <div class="cell">
                        <p>车辆进厂</p>
                        <div class="ico grayi" v-if="logisticsMsg.jczt == '未进厂'"><img src="../../../assets/img/orderstate/state6.png"></div>
                        <div class="ico bluei" v-else><img src="../../../assets/img/orderstate/state6.png"></div>
                        <!-- <span class="grayw">未进厂</span>
                        <span>已进厂</span> -->
                        <span>{{ logisticsMsg.jczt }}</span>
                    </div>
                    <div class="cell">
                        <p>整车状态</p>
                        <div class="ico grayi" v-if="logisticsMsg.zczt == '未装车'"><img src="../../../assets/img/orderstate/state7.png"></div>
                        <div class="ico bluei" v-else><img src="../../../assets/img/orderstate/state7.png"></div>
                        <!-- <span class="grayw">未装车</span>
                        <span>装车中</span> -->
                        <span>{{ logisticsMsg.zczt }}</span>
                    </div>
                </div>
                <div class="flexbox item itemmid">
                    <div class="cell">
                        <p>车辆出厂</p>
                        <div class="ico grayi" v-if="logisticsMsg.cczt == '未出厂'"><img src="../../../assets/img/orderstate/state8.png"></div>
                        <div class="ico bluei" v-else><img src="../../../assets/img/orderstate/state8.png"></div>
                        <!-- <span class="grayw">未出厂</span>
                        <span>已出厂</span> -->
                        <span>{{ logisticsMsg.cczt }}</span>
                    </div>
                </div>
                <div class="flexbox item itempadding" style="margin-top: 5px;">
                    <div class="cell">
                        <p>回款状态</p>
                        <div class="ico redi" v-if="logisticsMsg.hkzt == '已回款'"><img src="../../../assets/img/orderstate/state13.png"></div>
                        <div class="ico grayi" v-else><img src="../../../assets/img/orderstate/state13.png"></div>
                        <!-- <span class="grayw">未回款</span>
                        <span>已回款</span> -->
                        <span>{{ logisticsMsg.hkzt }}</span>
                    </div>
                    <div class="cell">
                        <p>发票邮寄状态</p>
                        <div class="ico grayi" v-if="logisticsMsg.yjzt == '未邮寄'"><img src="../../../assets/img/orderstate/state12.png"></div>
                        <div class="ico redi" v-else><img src="../../../assets/img/orderstate/state12.png"></div>
                        <!-- <span class="grayw">未邮寄</span>
                        <span>已邮寄</span> -->
                        <span>{{ logisticsMsg.yjzt }}</span>
                    </div>
                    <div class="cell">
                        <p>发票开具状态</p>
                        <div class="ico grayi" v-if="logisticsMsg.kpzt == '未开票'"><img src="../../../assets/img/orderstate/state11.png"></div>
                        <div class="ico redi" v-else><img src="../../../assets/img/orderstate/state11.png"></div>
                        <!-- <span class="grayw">未开具</span>
                        <span>已开具</span> -->
                        <span>{{ logisticsMsg.kpzt }}</span>
                    </div>
                    <!-- <div class="cell">
                        <p>到货签收</p>
                        <div class="ico grayi" v-if="logisticsMsg.qszt == '未签收'"><img src="../../../assets/img/orderstate/state10.png"></div>
                        <div class="ico redi" v-else><img src="../../../assets/img/orderstate/state10.png"></div>
                         <span class="grayw">未签收</span>
                        <span>已签收</span> 
                        <span>{{ logisticsMsg.qszt }}</span>
                    </div> -->
                    <div class="cell">
                        <p>在途状态</p>
                        <div class="ico grayi" v-if="logisticsMsg.ztzt == '未发货'"><img src="../../../assets/img/orderstate/state9.png"></div>
                        <div class="ico bluei" v-else><img src="../../../assets/img/orderstate/state9.png"></div>
                        <!-- <span class="grayw">未运输</span>
                        <span>运输中</span> -->
                        <span>{{ logisticsMsg.ztzt }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="ordermsg">
            <h6>
                <img src="../../../assets/img/ordermsg.png">
                <span>订单信息</span>
            </h6>
            <div class="con">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column
                        prop="date"
                        label="配送中心"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="提货单号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="交货单号">
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="一次物流发货订单"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="中心小微销售订单"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="中心小微提货单">
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="运单号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="车次号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="客户名称">
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="车牌号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="车队名称"
                        width="180">
                    </el-table-column>
                </el-table>
            </div>
        </div> -->
    </div>
</template>

<script>
    import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from 'vue'
    import { useRouter } from 'vue-router'

    export default {
        setup() {
            let { proxy } = getCurrentInstance()
            let router = useRouter()
            let pageData = reactive({
                orderCode: '',
                logbaseMsg: '',
                logisticsMsg: '',
                tableData: [],
            })
            // 获取订单物流
            let getLogistics = () => {
                let data = {
                    postType: 'queryWlInfo',
                    subOrderNo: pageData.orderCode, // 子订单号	
                }
                proxy.$axios.postReq('/meide/REST/ajaxOrderList', data)
                .then(res => {
                    if(res.success == 'true') {
                        pageData.logbaseMsg = res.data
                        pageData.logisticsMsg = res.state
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            onBeforeMount(() => {
                pageData.orderCode = router.currentRoute.value.query.ordercode
                getLogistics()
            })

            return {
                ...toRefs(pageData),
                getLogistics
            }
        }
    }
</script>

<style scoped lang="scss">
    .main {
        width: 1200px;
        margin: auto;
        padding: 80px 0;
    }
    h6 {
        display: flex;
        align-items: center;
        padding-bottom: 15px;
        border-bottom: 1px solid #0099ff;
        img {
            width: 25px;
            margin-right: 15px;
        }
        span {
            font-size: 16px;
            color: #999;
        }
    }
    .basemsg {
        .con {
            padding: 20px;
            justify-content: space-around;
            flex-wrap: wrap;
            .cell {
                width: 30%;
                margin: 10px 0;
                span {
                    color: #666;
                }
                p {
                    display: inline-block;
                    color: #666;
                }
                a {
                    color: #0099ff;
                    margin-left: 10px;
                    font-size: 12px;
                    &:hover {
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .orderstate {
        .con {
            width: 100%;
            height: 400px;
            padding: 20px;
            margin: 20px 0;
            background: url(../../../assets/img/liuchengbg.png) no-repeat;
            background-size: 100%;
            .item {
                justify-content: flex-end;
                .cell {
                    text-align: center;
                    width: 14%;
                    p {
                        background: #fff;
                    }
                    .ico {
                        margin: 10px auto;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 50px;
                        height: 50px;
                        border-radius: 200px;
                        img {
                            width: 25px;
                        }
                    }
                    .grayi {
                        background: #bbb;
                    }
                    .greeni {
                        background: #59c796;
                    }
                    .bluei {
                        background: #02a7f0;
                    }
                    .redi {
                        background: #f42434;
                    }
                    span {
                        font-size: 12px;
                        background: #fff;
                    }
                    .grayw {}
                }
            }
            .itemtop {
                justify-content: space-between;
            }
            .itemmid {
                margin: 25px 0;
                position: relative;
                right: -10px;
            }
            .itempadding {
                padding-right: 70px;
            }
        }
    }
    .ordermsg {
        .con {
            padding: 20px 0;
            ::v-deep(.el-table thead th ){
                background: #eee;
                color: #333;
                font-weight: bold;
            }
        }
    }
</style>